import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { LeistungEdit } from "../../Controlls/EditViews/LeistungEdit";
import { PopUpView } from "../../../Componente/PopUpView";
import { Leistung } from "../../../Api/DcoApi/Admin/AdminClasses2";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, LeistungEdit, PopUpView
  ],
  selector: 'Leistung',
  templateUrl: './Leistung.html',
  standalone: true,
  styleUrl: './Leistung.css'
})
export class LeistungList {
  @ViewChild('Grid') childComponent!: DataGridView<Leistung>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
